const LANGUAGES = [
  { key: "uk", label: "UA", isDefault: true },
  { key: "en", label: "ENG" },
]

const DEFAULT_LANG = LANGUAGES.find(l => l.isDefault).key

module.exports = { LANGUAGES, DEFAULT_LANG }
